// extracted by mini-css-extract-plugin
export default {"container":"style_container__eJANM","text":"style_text__ohhC4","flag":"style_flag__8t8fQ"};